(function () {
  console.log('[cart-drawer] script loaded');

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) {
    console.log('[cart-drawer] no #cart-drawer element found');
    return;
  }

 var drawerBody = drawer.querySelector('[data-cart-drawer-body]');
var drawerFooter = drawer.querySelector('[data-cart-drawer-footer]');
var headerCartCountEls = document.querySelectorAll('.cart-link .number[data-cart-count]');
var drawerCartCountEl = drawer.querySelector('[data-cart-count]');
var cartCountWrapperEls = document.querySelectorAll('.cart-link .number-wrapper');
var toggleButtons = document.querySelectorAll('[data-cart-toggle="cart-drawer"]');
var closeTriggers = drawer.querySelectorAll('[data-cart-close], [data-keep-shopping]');
var FREE_SHIPPING_THRESHOLD_CENTS = 7500;
var SHOPIFY_FORMS_TEASER_SELECTOR = 'shopify-forms-embed, [id*="shopify-forms"], [class*="shopify-forms"], iframe[src*="shopify"][src*="form"], iframe[title*="25%"], iframe[aria-label*="25%"]';

  var teaserObserver = null;
  var suppressedTeaserEls = [];

  function isDiscountTeaser(el) {
    if (!el || !el.getAttribute || drawer.contains(el)) return false;

    if (el.matches && el.matches(SHOPIFY_FORMS_TEASER_SELECTOR)) return true;

    var haystack = [
      el.getAttribute('aria-label'),
      el.getAttribute('title'),
      el.getAttribute('name'),
      el.id,
      el.className && typeof el.className === 'string' ? el.className : '',
      el.textContent
    ].filter(Boolean).join(' ').toLowerCase();

    return /get\s+(up\s+to\s+)?25%\s+off/.test(haystack) ||
      /up\s+to\s+25%\s+off/.test(haystack) ||
      (/25%\s+off/.test(haystack) && /teaser|popup|pop[- ]?up|shopify|newsletter|email|discount/.test(haystack));
  }

  function getTeaserContainer(el) {
    var current = el;

    while (current && current !== document.body && current.parentElement) {
      var style = window.getComputedStyle(current);
      var rect = current.getBoundingClientRect();

      if ((style.position === 'fixed' || style.position === 'sticky') && rect.width > 0 && rect.height > 0) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }

  function suppressDiscountTeasers() {
    var candidates = document.querySelectorAll(SHOPIFY_FORMS_TEASER_SELECTOR + ', iframe, [aria-label], [title], button, a, div, aside, section');

    candidates.forEach(function (candidate) {
      if (!isDiscountTeaser(candidate)) return;

      var target = getTeaserContainer(candidate);
      if (!target || drawer.contains(target) || target.hasAttribute('data-cart-drawer-suppressed-teaser')) return;

      target.setAttribute('data-cart-drawer-suppressed-teaser', 'true');
      target.setAttribute('data-cart-drawer-previous-display', target.style.display || '');
      target.style.display = 'none';
      suppressedTeaserEls.push(target);
    });
  }

  function startSuppressingDiscountTeasers() {
    suppressDiscountTeasers();

    if (!teaserObserver) {
      teaserObserver = new MutationObserver(function () {
        suppressDiscountTeasers();
      });
    }

    teaserObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title', 'class', 'style']
    });
  }

  function restoreDiscountTeasers() {
    if (teaserObserver) {
      teaserObserver.disconnect();
    }

    suppressedTeaserEls.forEach(function (el) {
      if (!el || !el.hasAttribute('data-cart-drawer-suppressed-teaser')) return;

      el.style.display = el.getAttribute('data-cart-drawer-previous-display') || '';
      el.removeAttribute('data-cart-drawer-suppressed-teaser');
      el.removeAttribute('data-cart-drawer-previous-display');
    });

    suppressedTeaserEls = [];
  }

  var teaserObserver = null;
  var suppressedTeaserEls = [];

  function isDiscountTeaser(el) {
    if (!el || !el.getAttribute || drawer.contains(el)) return false;

    var haystack = [
      el.getAttribute('aria-label'),
      el.getAttribute('title'),
      el.getAttribute('name'),
      el.id,
      el.className && typeof el.className === 'string' ? el.className : '',
      el.textContent
    ].filter(Boolean).join(' ').toLowerCase();

    return /get\s+(up\s+to\s+)?25%\s+off/.test(haystack) ||
      /up\s+to\s+25%\s+off/.test(haystack) ||
      (/25%\s+off/.test(haystack) && /teaser|popup|pop[- ]?up|shopify|newsletter|email|discount/.test(haystack));
  }

  function getTeaserContainer(el) {
    var current = el;

    while (current && current !== document.body && current.parentElement) {
      var style = window.getComputedStyle(current);
      var rect = current.getBoundingClientRect();

      if ((style.position === 'fixed' || style.position === 'sticky') && rect.width > 0 && rect.height > 0) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }

  function suppressDiscountTeasers() {
    var candidates = document.querySelectorAll('iframe, [aria-label], [title], button, a, div, aside, section');

    candidates.forEach(function (candidate) {
      if (!isDiscountTeaser(candidate)) return;

      var target = getTeaserContainer(candidate);
      if (!target || drawer.contains(target) || target.hasAttribute('data-cart-drawer-suppressed-teaser')) return;

      target.setAttribute('data-cart-drawer-suppressed-teaser', 'true');
      target.setAttribute('data-cart-drawer-previous-display', target.style.display || '');
      target.style.display = 'none';
      suppressedTeaserEls.push(target);
    });
  }

  function startSuppressingDiscountTeasers() {
    suppressDiscountTeasers();

    if (!teaserObserver) {
      teaserObserver = new MutationObserver(function () {
        suppressDiscountTeasers();
      });
    }

    teaserObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title', 'class', 'style']
    });
  }

  function restoreDiscountTeasers() {
    if (teaserObserver) {
      teaserObserver.disconnect();
    }

    suppressedTeaserEls.forEach(function (el) {
      if (!el || !el.hasAttribute('data-cart-drawer-suppressed-teaser')) return;

      el.style.display = el.getAttribute('data-cart-drawer-previous-display') || '';
      el.removeAttribute('data-cart-drawer-suppressed-teaser');
      el.removeAttribute('data-cart-drawer-previous-display');
    });

    suppressedTeaserEls = [];
  }

  function formatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getCart() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('Cart fetch failed');
      }
      return res.json();
    });
  }

  function updateFreeShippingBannerFromCart(cart) {
    var banner = drawer.querySelector('.cart-drawer__shipping[data-free-ship-banner="true"]');
    if (!banner || !cart) return;

    var threshold = parseInt(banner.getAttribute('data-free-ship-threshold'), 10) || FREE_SHIPPING_THRESHOLD_CENTS;
    var subtotal = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : (cart.total_price || 0);
    var remaining = threshold - subtotal;

    if (!cart.item_count) {
      banner.hidden = true;
      banner.setAttribute('hidden', 'hidden');
      return;
    }

    banner.hidden = false;
    banner.removeAttribute('hidden');

    if (remaining > 0) {
      banner.textContent = 'You\'re ' + formatMoney(remaining) + ' away from FREE shipping.';
    } else {
      banner.textContent = '✨ You\'ve unlocked FREE shipping!';
    }
  }

  console.log('[cart-drawer] toggleButtons found:', toggleButtons.length);
  console.log('[cart-drawer] closeTriggers found:', closeTriggers.length);

  // We support both the theme's "is-open" and our "cart-drawer--open" classes
  function openDrawer() {
    console.log('[cart-drawer] openDrawer()');
    drawer.classList.add('cart-drawer--open', 'is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll', 'cart-drawer-is-open');
    startSuppressingDiscountTeasers();
  }

  function closeDrawer() {
    console.log('[cart-drawer] closeDrawer()');
    drawer.classList.remove('cart-drawer--open', 'is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll', 'cart-drawer-is-open');
    restoreDiscountTeasers();
  }

  function syncFreeShippingBanner(newDrawer) {
    var currentBanner = drawer.querySelector('.cart-drawer__shipping[data-free-ship-banner="true"]');
    var newBanner = newDrawer ? newDrawer.querySelector('.cart-drawer__shipping[data-free-ship-banner="true"]') : null;

    if (!newBanner) {
      if (currentBanner) {
        currentBanner.hidden = true;
      }
      return;
    }

    if (!currentBanner) {
      var header = drawer.querySelector('.cart-drawer__header');
      if (header) {
        currentBanner = newBanner.cloneNode(true);
        header.insertAdjacentElement('afterend', currentBanner);
      }
      return;
    }

    currentBanner.innerHTML = newBanner.innerHTML;
    currentBanner.hidden = newBanner.hidden;
    if (newBanner.hasAttribute('hidden')) {
      currentBanner.setAttribute('hidden', 'hidden');
    } else {
      currentBanner.removeAttribute('hidden');
    }
  }

  function refreshDrawer() {
    console.log('[cart-drawer] refreshDrawer()');
    return fetch('/cart?view=drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        console.log('[cart-drawer] /cart?view=drawer status:', res.status);
        return res.text();
      })
      .then(function (html) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        var newDrawer = tempDiv.querySelector('#cart-drawer');
        if (!newDrawer) {
          console.log('[cart-drawer] newDrawer NOT found in response');
          return;
        }

        var newBody = newDrawer.querySelector('[data-cart-drawer-body]');
        var newFooter = newDrawer.querySelector('[data-cart-drawer-footer]');
        var newCount = newDrawer.querySelector('[data-cart-count]');

        syncFreeShippingBanner(newDrawer);

        getCart()
          .then(updateFreeShippingBannerFromCart)
          .catch(function (err) {
            console.warn('[cart-drawer] free shipping banner update failed', err);
          });

        if (newBody && drawerBody) {
          drawerBody.innerHTML = newBody.innerHTML;
          console.log('[cart-drawer] drawer body updated');
        }

        if (drawerFooter) {
          if (newFooter) {
            drawerFooter.innerHTML = newFooter.innerHTML;
            console.log('[cart-drawer] drawer footer updated');
          } else {
            drawerFooter.innerHTML = '';
            console.log('[cart-drawer] drawer footer cleared');
          }
        }

          if (newCount) {
            var count = parseInt(newCount.textContent, 10) || 0;

            // Update ALL header cart counts (desktop + mobile)
            headerCartCountEls.forEach(function (el) {
              el.textContent = count;
            });

            // Keep drawer's hidden count in sync
            if (drawerCartCountEl) {
              drawerCartCountEl.textContent = count;
            }

            // Show/hide the "(X)" wrapper(s) in all header cart links
            cartCountWrapperEls.forEach(function (wrapper) {
              if (count > 0) {
                wrapper.classList.remove('hide');
              } else {
                wrapper.classList.add('hide');
              }
            });

            console.log('[cart-drawer] cart count updated to', count);
}


      })
      .catch(function (err) {
        console.error('[cart-drawer] refreshDrawer error', err);
      });
  }

  // Header Cart(X) -> refresh + open drawer
  toggleButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('[cart-drawer] Cart(X) clicked');
      refreshDrawer().then(openDrawer);
    });
  });

  // Close drawer on overlay or close button
  closeTriggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('[cart-drawer] close trigger clicked');
      closeDrawer();
    });
  });

  // Close on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      if (drawer.classList.contains('cart-drawer--open') || drawer.classList.contains('is-open')) {
        console.log('[cart-drawer] ESC pressed, closing drawer');
        closeDrawer();
      }
    }
  });

    // Take over Add-to-Cart clicks before the theme's jQuery handler.
  // We run in the CAPTURE phase so jQuery never sees the event.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="add"], .add-to-cart, .product-form__cart-submit, button[type="submit"], input[type="submit"]');
    if (!btn) return;

    var form = btn.closest('form');
    if (!form) return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    console.log('[cart-drawer] CAPTURED add-to-cart click, action:', action);

    // Stop normal handling so the theme can't send /cart/add.js
    e.preventDefault();
    e.stopPropagation();

    var formData = new FormData(form);

    fetch('/cart/add', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (res) {
        console.log('[cart-drawer] /cart/add status:', res.status);
        return res.text();
      })
      .then(function () {
        console.log('[cart-drawer] calling refreshDrawer() after our add');
        return refreshDrawer();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function (err) {
        console.error('[cart-drawer] our /cart/add error', err);
      });
  }, true); // <-- IMPORTANT: capture phase
})();

